import { render, staticRenderFns } from "./ConfirmInvite.vue?vue&type=template&id=01a38232"
import script from "./ConfirmInvite.vue?vue&type=script&lang=js"
export * from "./ConfirmInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports